export default {
  title: 'Быстрый платёж',

  labels: {
    amount: 'Сумма',
    method: 'Метод'
  },

  methods: {
    v1: {
      tinkoff: 'Тинькофф'
    }
  },

  hints: {
    commission: 'Комиссия банка: 3%',
    commissions: 'Комиссия'
  },

  errors: {
    amount: 'Для оплаты в ссылке должна быть указана корректная сумма.',
    method: 'Для оплаты в ссылке должен быть указан корректный метод оплаты.',
    owner: 'Для оплаты в ссылке должен быть указан ID получателя.'
  }
}
